<template>
    <div>
        <section class="jumbotron text-center">
            <h1>Event details</h1>
            <p class="lead text-muted" v-if="company_name">{{company_name.value}}</p>
        </section>
        <section>
            <b-card-group columns>
                <b-card>
                    <h4>
                        Organizer
                        <b-badge style="float: right">
                            <i class="fa fa-user-circle"></i>
                        </b-badge>
                        
                    </h4>
                    {{account.id}}<br />
                    {{account.company_name}}<br />
                    {{account.email}}
                </b-card>
            </b-card-group>
        </section>
    </div>
</template>

<script>
import axios from "axios";
import store from "../store";

export default {
    name: "accountDetails",
    props: ["account_id"],
    data: () => {
        return {
            resources: {
                accounts: "/accounts"
            },
            account: {}
        };
    },
    methods: {
        fetchData() {
            return axios
                .get(this.$store.getters.apiBase + this.$data.resources.accounts + "/" + this.$props["account_id"], {
                    headers: {
                        "Content-Type": "application/json",
                        
                        Authorization: this.$store.getters.accessToken
                    }
                })
                .then(response => {
                    this.$data.account = response.data;
                    store.dispatch("changeAccount", this.$data.account.id);
                    
                    return response;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    watch: {
        "$route": "fetchData"
    },
    computed: {
        id() {
            return this.account ? this.account.id ? this.event.id : {} : undefined;
        },
        company_name() {
            return this.account ? this.account.company_name : undefined;
        },
        email() {
            return this.account ? this.account.email ? this.event.email : {} : undefined;
        }
    },
    created() {
        this.fetchData();
    }
};
</script>